import CustomTableau from "./CustomTableau";

export default CustomTableau;
